import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import clsx from 'clsx'
import deleteImg from '../../../assets/web/delete.png'

const Item = styled.tr`
  border-bottom: 1px solid #dbdfea;
  .item-name {
    font-weight: 600;
    color: #364a63;
  }
  ${tw`transition duration-200 ease-in-out transform cursor-pointer`}
`
const MOBILE_REG = /^1[3456789]\d{9}$/
const USERNAME_REG = /^[0-9a-zA-Z]{2,16}$/
const PWD_REG =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{8,16}$/

const TableItem = function ({
  row,
  userNames,
  existNames,
  existMobiles,
  deleteUser,
  mobiles,
}) {
  const renderTips = (cell) => {
    const { original, index } = cell.row
    if (cell.column.id === 'tip') {
      const tips = []
      const { name, username, password, repeatpwd, mobile } = original
      if (!name) {
        tips.push('用户姓名不能为空')
      }
      if (name && name.length > 40) {
        tips.push('用户姓名不能超过40字符')
      }
      if (!username) {
        tips.push('用户名不能为空')
      }
      if (username && existNames) {
        const repeat = userNames.filter((v) => v === username)
        console.log({ userNames, username })
        if (repeat.length > 1) {
          tips.push('用户名重复,请检查')
        }
        if (existNames[username] === 1) {
          tips.push('用户名已存在，请更换')
        }
      }
      if (!USERNAME_REG.test(username)) {
        tips.push('用户名需由2-16位数字或字母组成')
      }
      if (!password) {
        tips.push('用户密码不能为空')
      }
      if (!PWD_REG.test(password)) {
        tips.push(
          '用户密码至少8个字符，不超过16个字符，必须包含符号、数字和大小写字母组合'
        )
      }
      if (!repeatpwd) {
        tips.push('重复密码不能为空')
      }
      if (password && password !== repeatpwd) {
        tips.push('重复密码与用户密码不一致')
      }
      // 验证手机号
      if (!mobile) {
        tips.push('手机号不能为空')
      }
      if (mobile && existMobiles) {
        const repeat = mobiles.filter((v) => v === mobile)
        if (!MOBILE_REG.test(mobile)) {
          tips.push('手机号格式错误,请修改')
        }
        if (repeat.length > 1) {
          tips.push('手机号重复,请检查')
        }
        if (existMobiles[mobile] === 1) {
          tips.push('手机号已存在，请更换')
        }
      }
      if (tips.length > 0) {
        return (
          <div
            className="flex flex-col w-full text-error"
            style={{ fontSize: '0.8125rem' }}
          >
            {tips.map((v) => {
              return <span key={v}>{v}</span>
            })}
          </div>
        )
      }
      cell.value = true
      return <span className="text-info">格式正确</span>
    }

    return (
      <div
        className="ml-2"
        title="移除"
        onClick={() => {
          if (deleteUser) {
            deleteUser(index)
          }
        }}
      >
        <img alt="" className="w-3.5 h-3.5" src={deleteImg} />
      </div>
    )
  }
  return (
    <Item {...row.getRowProps()} key={row.original.id} className="flex pl-4">
      {row.cells.map((cell) => {
        const { column } = cell
        return (
          <td
            {...cell.getCellProps()}
            key={column.id}
            className={clsx([
              {
                'w-32 lg:w-1/6':
                  column.id !== 'selection' && column.id !== 'operate',
                'w-10': column.id === 'selection',
                'w-16 lg:w-1/6': column.id === 'operate',
                'item-name': column.id === 'name',
              },
              'flex items-center p-2',
            ])}
          >
            {column.id !== 'tip' && column.id !== 'operate'
              ? cell.render('Cell')
              : renderTips(cell)}
          </td>
        )
      })}
    </Item>
  )
}
export default TableItem
